/* eslint-disable @next/next/no-img-element */
import { LargeHeading, Paragraph, Section } from "../misc"
import HeroMD from "public/marketing/campaigns-hero.png"

export const Campaigns = () => {
  return (
    <Section className="text-center ">
      <div className="flex flex-col gap-1 text-center items-center pb-10 ">
        <LargeHeading>{`A/B test with fine-grained control`}</LargeHeading>
        <Paragraph className="!max-w-[750px] !text-opacity-60">{`Test as many paywalls as you like, users who match specific criteria. Build out
                  logic to determine who sees what.`}</Paragraph>
      </div>
      <img
        className="object-fill md:max-w-6xl min-w-[160vw] translate-x-[33vw] md:min-w-[1px] md:translate-x-0 md:w-[90%] sm:scale-100 origin-left"
        src={HeroMD.src}
        alt="dashboard-header"
      ></img>
    </Section>
  )
}
